<template>
  <div class="loginBox">
    <div class="login" v-on:keyup.enter="keyLogin" v-if="browser">
      <div class="loginBG">
        <div class="loginContent">
          <form action="">
            <div class="loginBox">
              <img src="../assets/img/login_logo.png" alt="" class="icon-login">
              <h4>习习教师</h4>
              <input type="text" placeholder="您的账号或手机号" class="loginInput" v-model.number="userName">
              <input type="password" placeholder="密码" class="pwdInput" v-model.number="paddWord">

              <div class="loginTools">
                <!-- <div :class="{checkbox:true,checked:isChecked}" @click="checking">
                                    <input type="checkbox">
                                </div>
                                自动登录 -->
                <div :class="{checkbox:true,checked:isChecked}" @click="rememberPassword">
                  <input type="checkbox">
                </div>
                记住密码
                <!-- <div class="ForgotPwd">
                                    <router-link to="ForgotPwd" style="color:#3C85F3;">
                                        找回密码
                                    </router-link>
                                </div> -->
              </div>
              <input type="button" value="登录" class="button loginBtn" @click="login" v-on:keyup.enter="keyLogin">
            </div>

          </form>
          <!-- <div class="log_register">
                        <p @click="register">注册新账号</p>
                    </div> -->
        </div>
        <a :href="loadUrl" class="download" v-if="isDownload">下载客户端</a>
      </div>
    </div>
  </div>
</template>
<script>
import fetch from "./../fetch";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isChecked: false,
      userName: "", //70018520,492976026,70020437
      paddWord: "",
      isFocus: false,
      browser: true,
      isDownload: false,
      loadUrl: ''
    };
  },
  created() {
    this.$nextTick(() => {
      window.sessionStorage.setItem('studentsListData', [])
      window.sessionStorage.setItem('studentsTemp', [])
      let strName = localStorage.getItem("keyName");
      let strPass = localStorage.getItem("keyPass");
      if (strName && strPass) {
        this.userName = strName;
        this.paddWord = strPass;
        this.isChecked = true;
      }
      this.setState([0, 0]);
      this.isChecked = true;
      this.downFun();
    });
  },
  methods: {
    ...mapGetters(["getUser"]),
    ...mapActions(["setUser", "setToast", "removeUser", "setState"]),
    login() {
      if (this.userName.length == 0) {
        this.$toast("账号不能为空", "error");
        return;
      }
      if (this.userName.length != 0 && this.paddWord.length == 0) {
        this.$toast("密码不能为空", "error");
        return;
      }
      fetch
        .login({ username: this.userName, password: this.paddWord.toString() })
        .then(
          res => {
            if (!res.data) {
              this.$toast("账号或密码错误", "error");
              return false;
            }
            //  let obj ={"userId":this.userName,"clientId":100143,"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjcwMDE4NTIwLCJjbGllbnRJZCI6IjEwMDE0MyIsIm1vYmlsZSI6IjEzMDExMTExMTExIiwicmVhbE5hbWUiOiLmoJflrZDogIHluIjkuIAiLCJuaWNrTmFtZSI6Iuagl-WtkOiAgeW4iOS4gCIsImF2YXRhciI6IiIsImlhdCI6MTUwNjU5NDgzNH0.sudUdXHibosWTBWECRNtLQWRBbBUpdDHQHSTxIl05mw","mobile":"13011111111","realName":"栗子老师一","nickName":"栗子老师一","avatar":"","brandId":524726977,"schoolId":0,"brandName":"测试用","logo":"http://rimg3.ciwong.net/6v68/tools/images/155014/4a399d2a0ea8c1d3baff62fb21fb96898d7e4359.png","host":"http://eapi.my.jiaofucloud.cn","qudao":"http://qudao.jiaofuyun.site","username":"70018520","password":"123456","isUnread":false}
            if (res.data.accessToken) {
              this.setUser(res.data);
              //  window.localStorage.setItem("user",JSON.stringify({"Name}));
              // 登录成功后跳转到布置作业
              this.$router.push({ path: "web/selectGrade" });
              localStorage.setItem("keyName", this.userName);
              if (this.isChecked) {
                localStorage.setItem("keyPass", this.paddWord);
              } else {
                localStorage.removeItem("keyPass");
              }

              // 登录成功存储班级列表
              fetch.grads({ userRole: 2 }).then(res => {
                if (!res) {
                  return false;
                }
                let arr = [];
                let grads = res.data;
                for (let i = 0; i < grads.length; i++) {
                  let item = grads[i];
                  arr.push({
                    title: item.className,
                    path: "classManage"
                  });
                }
                window.sessionStorage.setItem("classListData", JSON.stringify(arr));
              });
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    // 记住密码
    rememberPassword() {
      this.isChecked = !this.isChecked;
    },
    autoLogin() {
      if (
        window.localStorage.userName &&
        window.localStorage.userName != "underfined"
      ) {
        this.userName = JSON.parse(
          window.localStorage.getItem("userName")
        ).Name;
      }
      if (
        window.localStorage.passWord &&
        window.localStorage.passWord != "underfined"
      ) {
        this.paddWord = JSON.parse(
          window.localStorage.getItem("passWord")
        ).paddWord;
      }
      this.login();
    },
    //键盘事件
    keyLogin() {
      this.login();
    },
    downFun () {
      const version = navigator.userAgent.match(/Chrome\/(.*?) Safari/)[1]
      const v = version.split('.')[0]
      if (v > 49){
        this.isDownload = true;
        this.loadUrl = apps.xi.web || 'http://xi.my.ciwong.com'
        // fetch.downLoad().then(res => {
        //   console.log(res)
        // })
      }
    }
    // register() {
    //   this.$router.push({ path: "register" });
    // }
  }
};
</script>



// WEBPACK FOOTER //
// login.vue?1be869ba